class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.product-tabs-tab');
    this.panels = this.querySelectorAll('.product-tabs-panel');

    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        this.activateTab(tab.dataset.tabId);
      });
    });
  }

  activateTab(tabId) {
    this.tabs.forEach(tab =>
      tab.classList.toggle('is-active', tab.dataset.tabId === tabId)
    );

    this.panels.forEach(panel =>
      panel.classList.toggle('is-active', panel.id === tabId)
    );
  }
}

customElements.define('product-tabs', ProductTabs);